import { Vector3 } from "three";
import { Control3d } from "../display3d/Control3d.js";
import { VOSceneStorage } from "../model/DataStructure.js";
import { MarkerLayer } from "./MarkerLayer.js";

export interface EditListOptions {
    container: HTMLElement;
    items: EditListItemOptions[];
    onSelect?: (item: EditListItem) => void;
    control: Control3d;
    saveUrl: string;
    markerLayer: MarkerLayer
    ;
}

export class EditList {

    public onSelect = e5.Signal.create<[EditListItem]>();

    private _element: HTMLDivElement;
    private _items: EditListItem[] = [];
    private _current: EditListItem = null;
    private _saveUrl: string;
    private _markerLayer: MarkerLayer;
    private _submitting: boolean = false;

    constructor(options: EditListOptions) {
        this._element = document.createElement("div");
        this._element.className = "awi-edit-list";
        this._element.innerHTML = `
        <div class="awi-edit-list__list"></div>
        <div class="awi-edit-list__control">
            <button class="awi-edit-list__control-button awi-edit-list__control-button--submit" data-action="submit"><span class="fal fa-arrow-from-bottom"></span> Speichern</button>
        </div>
        `;

        this._saveUrl = options.saveUrl;
        options.container.appendChild(this._element);
        this._markerLayer = options.markerLayer;


        if (typeof options.onSelect === "function") {
            this.onSelect.add(options.onSelect);
        }

        for (let o of options.items) {
            this.add(o);
        }

        this.onSelect.add(
            (item) => {
                options.control.showTransform = Boolean(item);
                // this._markerLayer.visible = !Boolean(item);
                this._markerLayer.disabled = Boolean(item);

                if (!item) {
                    return;
                }

                options.control.show(item.storage);
            }
        );

        options.control.onChange.add(() => {
            if (!this.current) {
                return;
            }

            this.setSceneStorage(
                options.control.getSceneStorage(
                    this.current.storage.id,
                    this.current.storage.kind)
            );
        });

        e5.event.on({
            type: "click",
            scope: this._element,
            selector: `[data-action="submit"]`,
            listener: (e) => {
                this.submit();
            }
        })
    }

    public add(options: EditListItemOptions): void {

        const item = new EditListItem(options);
        this._items.push(item);
        item.onClick.add(() => {
            this.current = item;
        });

        const list = this._element.querySelector(".awi-edit-list__list");
        list.appendChild(item.element);
    }

    public getSceneStorage(): VOSceneStorage[] {
        let result: VOSceneStorage[] = [];
        for (let item of this._items) {
            result.push(item.storage);
        }
        return result;
    }

    public setSceneStorage(storage: VOSceneStorage) {
        if (!this._current) {
            return;
        }
        this._current.storage = storage;
    }

    public get current(): EditListItem {
        return this._current;
    }

    public set current(value: EditListItem) {
        // if (this._current == value) {
        //     if (this._current) {
        //         this.onSelect.dispatch(this._current);
        //     }
        //     return;
        // }

        if (this._current == value) {
            value = null;
        }

        if (this._current) {
            this._current.selected = false;
        }
        this._current = value;
        if (this._current) {
            this._current.selected = true;
        }

        this.onSelect.dispatch(this._current);
    }

    private get submitable():boolean{
        return !this._element.querySelector(`.awi-edit-list__control-button--submit`)
        .classList.contains("awi-edit-list__control-button--disabled");
    }

    private set submitable(value:boolean){
        this._element.querySelector(`.awi-edit-list__control-button--submit`)
        .classList.toggle("awi-edit-list__control-button--disabled", !value);
    }

    private async submit() {
        if (this._submitting) {
            return;
        }
        this._submitting = true;
        this.submitable = false;

        const response: any = await e5.load(
            "json",
            this._saveUrl,
            {
                data: {
                    data: {
                        items: this.getSceneStorage()
                    }
                }
            }
        );

        if (response?.kind === 'success') {
            console.log("RESPONSE", response);
            e5.Toast.showText("Daten wurden gespeichert!");
        } else {
            console.log("RESPONSE", response);
            e5.Toast.showText("Leider ist etwas schief gelaufen.");
        }

        this._submitting = false;
        this.submitable = true;
    }
}

export interface EditListItemOptions {
    label: string;
    icon: string;
    storage: VOSceneStorage;
}

export class EditListItem {


    public onClick = e5.Signal.create<[EditListItem]>();

    public readonly element: HTMLElement;
    private _storage: VOSceneStorage;


    constructor(options: EditListItemOptions) {
        const e = document.createElement("button");
        e.className = "awi-edit-list__item";
        e.title = "ID | " + options.storage.id;
        e.innerHTML = `
        <span class="awi-edit-list__item-icon ${options.icon}"></span>
        <span class="awi-edit-list__item-label">${e5.Text.escapeHtml(options.label)}</span>
        `;
        this.element = e;

        this.element.addEventListener("click", (e) => {
            this.onClick.dispatch(this);
        });

        this._storage = options.storage;
    }

    public get storage(): VOSceneStorage {
        return this._storage;
    }
    public set storage(value: VOSceneStorage) {
        this._storage.camera_x = value.camera_x;
        this._storage.camera_y = value.camera_y;
        this._storage.camera_z = value.camera_z;

        this._storage.target_x = value.target_x;
        this._storage.target_y = value.target_y;
        this._storage.target_z = value.target_z;
    }

    public get selected(): boolean {
        return this.element.classList.contains("awi-edit-list__item--selected");
    }

    public set selected(value: boolean) {
        this.element.classList.toggle("awi-edit-list__item--selected", value);
    }
}